import queryString from "query-string";
import services from "../../../../services";
import $ from 'jquery';

let data = [];

const generateId = data =>
    data.reduce((acc, current) => Math.max(acc, current.ProductID), 0) + 1;

export const insertItem = item => {
    item.ProductID = generateId(data);
    item.inEdit = false;
    item.IDAutoDetalhe = 0;
    item.Columns = [];
    data.unshift(item);
    return data;
};

export const deleteAll = () => {
    data = [];
    return data;

};
export const dataGet11 = async () => {
    return data;
};

// export const getItems11 = async () =>  {
//     console.log("services11")   
//     return data
// };
export const getItems11= async () =>  {
    console.log("services4")
    if(window.location.search != ""){
        var queryParams = queryString.parse(window.location.search)
        var  token = queryParams.idAuto
        var  dataToken = {"idAuto": token}
        var Detalhes = await services.apiCall.requestApi(
            "/Fiscalizacao/GetAutoDetalhe",
            dataToken,
            "get"
        ); 
       
            for (let i = 0; i < Detalhes.autoGridSelosGarantia.length ; i++) {
                var EntidadesInstEng = Detalhes.autoGridGranel[i].idAgenteEconomico;
                var idTipoSelo = Detalhes.autoGridSelosGarantia[i].idTipoSelo;
                var SerieSelo = Detalhes.autoGridSelosGarantia[i].serieSelo;
                var IDRegistoSelo = Detalhes.autoGridSelosGarantia[i].idRegistoSelo;
                var IntervaloSelo = Detalhes.autoGridSelosGarantia[i].intervaloSelo;
                var NumeroSeloInicial = Detalhes.autoGridSelosGarantia[i].numeroSeloInicial;
                var NumeroSeloFinal = Detalhes.autoGridSelosGarantia[i].numeroSeloFinal;
                var QuantidadeSelos = Detalhes.autoGridSelosGarantia[i].qtSelosCarteira;
                
                var TipoSelo = Detalhes.autoGridSelosGarantia[i].tipoSelo;
                var idAutoDetalhe1 = Detalhes.autoGridSelosGarantia[i].idAutoDetalhe;
                    data.push({ 
                        idEntidadesInst : EntidadesInstEng,
                        EntidadesInst : EntidadesInstEng,
                        TipoSelo : {text: TipoSelo, value: idTipoSelo},
                        Serie_selosGarantia : {text: SerieSelo, value: IDRegistoSelo},
                        intervalosDisponiveis_selosGarantia : {text: IntervaloSelo, value: IDRegistoSelo},
                        Nr_Selo_inicial_selosGarantia : NumeroSeloInicial,
                        Nr_Selo_final_selosGarantia: NumeroSeloFinal,
                        QTSelosCarteira: QuantidadeSelos,
                        Discontinued: false,
                        idAutoDetalhe: idAutoDetalhe1,
                        Columns: [],
                        inEdit: false,
                        ProductID: i + 1,
                    })
        }
        return data;
    }else{
         return data
    }
    
};

export const updateItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data[index] = item;
    return data;
};

export const deleteItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data.splice(index, 1);
    return data;
};
